import { lazy } from 'react';

import { formDrawerRegistry, type FormDrawerParams } from '@/app/surfaces/form-drawer-registry.js';

export const OpenReception_DRAWER_KEY = 'service-order.open-reception';

function resolveContextBadge(params: FormDrawerParams): string | undefined {
  const contextLabel = params['contextLabel'];
  if (typeof contextLabel !== 'string' || contextLabel.trim().length === 0) {
    return undefined;
  }

  return `para ${contextLabel.trim()}`;
}

formDrawerRegistry[OpenReception_DRAWER_KEY] = {
  title: 'Nova recepção',
  size: 'lg',
  // TODO(harness): icon: createElement(ShellIconX, { size: 14 }),
  badge: resolveContextBadge,
  component: lazy(async () => {
    const module = await import('@/features/service-order/surfaces/open-reception.drawer.js');
    return { default: module.OpenReceptionDrawer };
  }),
};
